<template>
  <div class="sellCenter container">
    <!-- 过滤条件start -->
    <div ref="headerBtn" class="headerBtn">
      <el-form
      v-if='false'
        :inline="true"
        :model="formInline"
        size="mini"
        class="demo-form-inline"
      >
        <el-form-item label="品种">
          <el-select
            style="width: 100px"
            v-model="formInline.region"
            placeholder="全部"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="等级">
          <el-select
            style="width: 100px"
            v-model="formInline.region"
            placeholder="全部"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="产地">
          <el-select
            style="width: 100px"
            v-model="formInline.region"
            placeholder="全部"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="均重">
          <el-select
            style="width: 100px"
            v-model="formInline.region"
            placeholder="全部"
          >
            <el-option label="区域一" value="shanghai"></el-option>
            <el-option label="区域二" value="beijing"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="info" @click="onSubmit">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- 顶部按钮start -->
      <div>
        <el-button @click="toAddWhiteBar" size="mini" type="info"
          >添加白条</el-button
        >
        <!-- <el-button size="mini" type="info">导入白条</el-button> -->
        <el-button size="mini" @click="resetPage" type="info">重置</el-button>
      </div>
      <!-- 顶部按钮end -->
    </div>
    <!-- 过滤条件end -->
    <div :style="{ height: tabHeight }">
      <el-table
        :data="list"
        border
        v-loading="loading"
        size="mini"
        :height="tabHeight"
        :style="{ 'background-color': 'transparent' }"
        :header-cell-style="{ 'background-color': '#f8f8f8' }"
      >
        <el-table-column align="center" label="序号" type="index" width="50">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          prop="image"
          align="center"
          label="白条封面"
          width="180"
        >
          <template slot-scope="scope">
            <el-image
              style="width: 50px; height: 50px"
              :src="getImageUrl(scope.row.image)"
              fit="cover"
            ></el-image>
          </template>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="breed"
          label="白条品种"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          prop="grade"
          :formatter="geadeFormatter"
          label="白条等级"
          width="150"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="birthPlace"
          :formatter="placeFormatter"
          label="白条产地"
        >

        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          prop="weight"
          label="均重(kg)"
        >
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          align="center"
          width="150"
          label="操作"
        >
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页start -->
    <div class="pagination">
      <el-pagination
        background
        layout="total, prev, pager, next, jumper"
        :total="total"
        :current-page="pageIndex"
        @current-change="handleCurrentChange"
        :page-size="15"
      >
      </el-pagination>
    </div>
    <!-- 分页end -->
  </div>
</template>

<script>
import { queryMyWhiteBarList, getImageUrl, getAreaByAreaId } from "@/api/api";
import { mapState } from "vuex";
export default {
  name: "whitebar",
  data() {
    return {
      tabHeight: "300px",
      formInline: {
        user: "",
        region: "",
      },
      list: null,
      loading: false,
      total: 0,
      pageIndex: 1,
    };
  },
  mounted() {
    this.setTableHeight();
    window.addEventListener("resize", this.setTableHeight);
    this.initData();
    this.getImageUrl = getImageUrl;
  },
  computed: {
    ...mapState(["userInfo"]),
  },
  methods: {
 handleCurrentChange(e) {
      console.log(e);
      this.pageIndex = e;
      setTimeout(() => {
        this.initData();
      });
    },
    resetPage() {
      this.$router.go(0);
    },
    placeFormatter(row) {
      console.log(row.birthPlace);
      let area = getAreaByAreaId(row.birthPlace);
      return area.province;
    },
    geadeFormatter(row, column) {
      switch (row.grade) {
        case 1:
          return "一级";
        case 2:
          return "二级";
        case 3:
          return "三级";
        case 4:
          return "四级";
        case 5:
          return "五级";
      }
    },
    initData() {
      let that = this;
      console.log("this.userInfo", this.userInfo);
      let data = {
        access_token: this.userInfo.access_token,
        storeId: this.userInfo.storeId,
        pageIndex: this.pageIndex-1,
        pageSize: 15,
      };

      let param = new URLSearchParams();

      for (var k in data) {
        param.append(k, data[k]);
      }
      this.loading = true;
      this.$axios({ method: "post", data: param, url: queryMyWhiteBarList })
        .then(function (res) {
          that.loading = false;
          if (res.data.resultCode == 1) {
            console.log("res.data", res.data.data);
            that.list = res.data.data;
            that.total = res.data.count
          } else {
            that.$alert(`${res.data.resultMsg}`, "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch( (error) =>{
          that.loading = false;
          that.$alert("请求异常:" + error, "提示", {
            confirmButtonText: "确定",
          });
        });
    },
    toAddWhiteBar() {
      this.$router.push("/sellCenter/addWhitebar");
    },
    onSubmit() {
      console.log("submit!");
    },
    setTableHeight() {
      //
      setTimeout(() => {
        let headerBtn = document.getElementsByClassName("headerBtn")[0]
          .offsetHeight;
        let paginationBtn = document.getElementsByClassName("pagination")[0]
          .offsetHeight;
        let tabHeight = window.innerHeight - headerBtn - paginationBtn - 110;
        if (tabHeight < 300) {
          tabHeight = 300;
        }
        this.tabHeight = tabHeight + "px";
      });
    },
  },
};
</script>

<style scoped lang='less'>
.headerBtn {
  width: 90%;
  margin-bottom: 10px;
  overflow: auto;
}
.container {
  margin: 10px;
}
.pagination {
  margin-top: 10px;
  width: 200px;
  display: flex;
  justify-content: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCenter/Whitebar.vue